var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "location_svg__a",
    d: "M.74 1.216h33.752v43.05H.74z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F1",
    fillRule: "nonzero",
    d: "M32.31 36.2l-10.305-2.22-10.508 2.22L3 62.784l14.756-2.22 14.553 2.22 13.54-2.281 15.77 2.281L53.122 36.2l-11.52-2.281z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.85 60.502l15.769 2.282L53.122 36.2l-11.52-2.281 4.247 26.583zm-28.093.061l14.554 2.221V36.198l-10.306-2.22-4.248 26.585z",
    fill: "#E3E3E3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.664 .238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "location_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#location_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.615 1.216C8.297 1.216.74 8.457.74 17.386c0 7.552 12.066 22.084 15.794 26.391.266.31.663.49 1.083.49.414 0 .808-.178 1.081-.49 3.729-4.31 15.794-18.839 15.794-26.39 0-8.93-7.556-16.171-16.877-16.171",
    fill: "#E05B5B",
    fillRule: "nonzero",
    mask: "url(#location_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.404 17.626c0 7.549 12.066 22.083 15.794 26.39a1.43 1.43 0 001.081.487V1.454c-9.318 0-16.875 7.24-16.875 16.17",
    fill: "#FB6566",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.226 16.282c0 3.244-2.662 5.875-5.947 5.875-3.284 0-5.947-2.63-5.947-5.875 0-3.246 2.663-5.877 5.947-5.877 3.285 0 5.947 2.63 5.947 5.875",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0uNzQgMS4yMTZoMzMuNzUydjQzLjA1SC43NHoiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCAwaDY0djY0SDB6Ii8+PHBhdGggZmlsbD0iI0YwRjFGMSIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMzIuMzEgMzYuMmwtMTAuMzA1LTIuMjItMTAuNTA4IDIuMjJMMyA2Mi43ODRsMTQuNzU2LTIuMjIgMTQuNTUzIDIuMjIgMTMuNTQtMi4yODEgMTUuNzcgMi4yODFMNTMuMTIyIDM2LjJsLTExLjUyLTIuMjgxeiIvPjxwYXRoIGQ9Ik00NS44NSA2MC41MDJsMTUuNzY5IDIuMjgyTDUzLjEyMiAzNi4ybC0xMS41Mi0yLjI4MSA0LjI0NyAyNi41ODN6bS0yOC4wOTMuMDYxbDE0LjU1NCAyLjIyMVYzNi4xOThsLTEwLjMwNi0yLjIyLTQuMjQ4IDI2LjU4NXoiIGZpbGw9IiNFM0UzRTMiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjY2NCAuMjM4KSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTE3LjYxNSAxLjIxNkM4LjI5NyAxLjIxNi43NCA4LjQ1Ny43NCAxNy4zODZjMCA3LjU1MiAxMi4wNjYgMjIuMDg0IDE1Ljc5NCAyNi4zOTEuMjY2LjMxLjY2My40OSAxLjA4My40OS40MTQgMCAuODA4LS4xNzggMS4wODEtLjQ5IDMuNzI5LTQuMzEgMTUuNzk0LTE4LjgzOSAxNS43OTQtMjYuMzkgMC04LjkzLTcuNTU2LTE2LjE3MS0xNi44NzctMTYuMTcxIiBmaWxsPSIjRTA1QjVCIiBmaWxsLXJ1bGU9Im5vbnplcm8iIG1hc2s9InVybCgjYikiLz48L2c+PHBhdGggZD0iTTIxLjQwNCAxNy42MjZjMCA3LjU0OSAxMi4wNjYgMjIuMDgzIDE1Ljc5NCAyNi4zOWExLjQzIDEuNDMgMCAwIDAgMS4wODEuNDg3VjEuNDU0Yy05LjMxOCAwLTE2Ljg3NSA3LjI0LTE2Ljg3NSAxNi4xNyIgZmlsbD0iI0ZCNjU2NiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTQ0LjIyNiAxNi4yODJjMCAzLjI0NC0yLjY2MiA1Ljg3NS01Ljk0NyA1Ljg3NS0zLjI4NCAwLTUuOTQ3LTIuNjMtNS45NDctNS44NzUgMC0zLjI0NiAyLjY2My01Ljg3NyA1Ljk0Ny01Ljg3NyAzLjI4NSAwIDUuOTQ3IDIuNjMgNS45NDcgNS44NzUiIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvZz48L3N2Zz4=";
export { SvgLocation as ReactComponent };